import { useQuery } from "@tanstack/react-query";
import localeCore from "../../core/locale.core";
import useGetBrand from "../../hooks/useGetBrand.hook";
import ErrorCenterIcon from "../../icons/exclamationTriangleCenter.icon";
import LoadingOvalIcon from "../../icons/loadingOval.icon";
import attributeCore from "../../core/attribute.core";



export default function AttributeName({ attrId }: { attrId: string }) {
  const {
    data: atrr,
    isPending,
    isError,
    error,
  } = useQuery({
    queryKey: ["attribute", attrId],
    queryFn: (context) => attributeCore.getAttribute(context.queryKey[1]),
  });

  if (isPending) return <LoadingOvalIcon />;
  if (isError) return <ErrorCenterIcon reason={error.message} />;
  if (!atrr) return null;

  return <span data-label={`attr-${atrr.code}`}>{localeCore.getLocaleValueDefaultFallback(atrr.name)}</span>;
}
